import { AdminSidebar } from 'stylemix-vue-admin'

const sidebarMenuItems = [
  {
    id: 'ZONE_EDITOR',
    order: 80,
    header: $vm => $vm.$t(`general.menu_settings`),
    text: $vm => $vm.$t(`zones.zones`),
    route: '/zones',
    icon: 'icon-map5',
    permission: 'administer',
  },
]

AdminSidebar.setMenu(sidebarMenuItems)
